import React, { useEffect, useRef, useState } from "react";
import back from "../../Asset/testimonial/back.jpg";
import grass from "../../Asset/testimonial/grass.svg";
import AOS from "aos";
import "aos/dist/aos.css";
import Cards from "./component/Cards"; // Assuming this component is imported
import { TiArrowLeftThick } from "react-icons/ti";
import { TiArrowRightThick } from "react-icons/ti";

const Blank = () => {
  const Data = [
    {
      id: 1,
      name: "Soni Yaswal",
      comment:
        "Pure, fresh, and trustworthy! Their organic products have transformed our meals. Highly recommend!",
      image:
        "https://i.pinimg.com/originals/f6/fc/1e/f6fc1e646a153ca356a5aaf6d6daed2a.jpg",
    },
    {
      id: 2,
      name: "Moni Yaswal",
      comment:
        "Pure, fresh, and trustworthy! Their organic products have transformed our meals. Highly recommend!",
      image:
        "https://i.pinimg.com/originals/f6/fc/1e/f6fc1e646a153ca356a5aaf6d6daed2a.jpg",
    },
    // Add more data as needed
  ];

  const scrollRef = useRef(null);
  const [cardWidth, setCardWidth] = useState(0);

  useEffect(() => {
    // Ensure that the width is set correctly after component mounts
    if (scrollRef.current) {
      setCardWidth(scrollRef.current.offsetWidth); // Get the container width
    }
  }, []);

  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: -cardWidth,
        behavior: "smooth",
      });
    }
  };

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: cardWidth,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <div
      className="pt-6 pl-6 pr-6 pb-56 sm:pb-44 md:pt-10 md:pl-10 md:pr-10 lg:pb-48 relative px-4 md:px-12"
      data-aos="fade-left"
      style={{
        backgroundImage: `url(${back})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "top center",
        backgroundSize: "cover",
        minHeight: "100vh",
      }}
    >
      <div className="absolute bottom-16 sm:bottom-0 right-0">
        <div>
          <img src={grass} alt="grass" />
        </div>
      </div>

      {/* Header */}
      <div className="flex justify-between items-center mb-8">
        <div>
          <h2 className="text-xl md:text-4xl font-bold text-textColor title">Testimonials</h2>
          <p className="text-base md:text-2xl mt-2 text-textColor">
            We Deliver Lifeline, Here’s what people say
          </p>
        </div>
        <div className="hidden sm:flex gap-4 sm:gap-6 text-3xl text-textColor">
          <div
            className="bg-textColor text-Background1 w-10 h-10 sm:w-11 sm:h-11 flex justify-center items-center rounded-full cursor-pointer"
            onClick={scrollLeft}
          >
            <TiArrowLeftThick />
          </div>
          <div
            className="bg-textColor text-Background1 w-10 h-10 sm:w-11 sm:h-11 flex justify-center items-center rounded-full cursor-pointer"
            onClick={scrollRight}
          >
            <TiArrowRightThick />
          </div>
        </div>
      </div>

      {/* Horizontal Scroll */}
      <div className="overflow-x-auto">
        <div
          ref={scrollRef}
          className="flex gap-8 overflow-x-auto"
          style={{  scrollBehavior: "smooth" }}
        >
          {Data?.map((item, index) => (
            <div key={index} className="flex-shrink-0 w-[100%] sm:w-[48%] lg:w-[32%]">
              <Cards item={item} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Blank;